<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    overlay-opacity="grey darken-2"
    dark
    floating
    persistent
    width="360"
    src="@/assets/cloud-sky-stock-photography-blue-sunlight-sky.jpg"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .8)"
      />
    </template>
    <v-container>
      <v-row>
        <v-spacer />
        <v-img
          src="@/assets/hypermeteo-marchio.png"
          width="130"
        />
        <v-spacer />
      </v-row>
    </v-container>

    <v-divider class="mx-3 mb-3" />

    <v-list>
      <v-list-item
        active-class="primary white--text"
        to="/"
      >
        <v-list-item-action>
          <v-icon>mdi-shield-account-outline</v-icon>
        </v-list-item-action>

        <v-list-item-title>
          Admin
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        active-class="primary white--text"
        to="/customers"
      >
        <v-list-item-action>
          <v-icon>mdi-card-account-details-outline</v-icon>
        </v-list-item-action>

        <v-list-item-title>
          Customers
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        active-class="primary white--text"
        to="/api-policy"
      >
        <v-list-item-action>
          <v-icon>mdi-code-json</v-icon>
        </v-list-item-action>

        <v-list-item-title>
          Api Policy
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        active-class="primary white--text"
        to="/domain"
      >
        <v-list-item-action>
          <v-icon>mdi-image-filter-hdr</v-icon>
        </v-list-item-action>

        <v-list-item-title>
          Domain
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,

      admins: [
        ['Management', 'mdi-account-multiple-outline'],
        ['Settings', 'mdi-cog-outline']
      ]
    }
  },
  data () {
    return {
      ticketingArray: []
    };
  },
  computed: {
    ...mapState(['services', 'drawer', 'layers', 'customer', 'app_user']),
    inputValue: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(['setDrawer', 'toggleDrawer'])
  }
};
</script>

<style scoped>
.serviceItems {
  font-size: 14px;
  margin-left: 70px;
}

.transparent-backgroud-class {
  background-color: transparent;
}
.submenu-size{
  font-size: 13.5px;
}
</style>
